import { formatCurrency } from '@acorn-portal/shared/src/utils/formatter';
import { TableCell, TableRow, Table, TableHead, Paper, TableContainer, TableBody, Box } from '@mui/material';
import { FeeType } from '@acorn-portal/shared/src/services/cancellation-api';

interface RefundBreakdownProps {
	refundAmount: number;
	cancellationFee: number;
	totalRefundAmount: number;
	feeType: FeeType;
}

const RefundBreakdown = ({ refundAmount, cancellationFee, totalRefundAmount, feeType }: RefundBreakdownProps) => {
	return (
		<Box sx={{ mb: '16px' }}>
			<TableContainer
				component={Paper}
				elevation={0}
				sx={{ border: '1px solid #EDEDED', borderRadius: '8px', alignSelf: 'flex-start', position: 'relative' }}
			>
				<Table>
					<TableHead sx={{ visibility: 'hidden', height: '1px', width: '1px', position: 'absolute', top: 0, left: 0 }}>
						<TableRow>
							<TableCell>Section</TableCell>
							<TableCell>Amount</TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						<TableRow>
							<TableCell>Refund Amount</TableCell>
							<TableCell>
								<strong>{formatCurrency(refundAmount)}</strong>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>
								{feeType === FeeType.CancellationFee ? 'Cancellation Fee' : 'Refund of Arrangement'}
							</TableCell>
							<TableCell>
								<strong>{formatCurrency(cancellationFee)}</strong>
							</TableCell>
						</TableRow>
						<TableRow sx={(theme) => ({ backgroundColor: theme.palette.primary.light })}>
							<TableCell>
								<strong>Total Refund Amount</strong>
							</TableCell>
							<TableCell>
								<strong>{formatCurrency(totalRefundAmount)}</strong>
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default RefundBreakdown;
